import React, { useContext, useEffect, useState } from "react";
import { LoaderContext, getContext } from "../../../Helpers/Context/Context";

import axios from "axios";
import fileDownload from "js-file-download";
import { APICall } from "../../../Helpers/Network/APICalls";
import moment from "moment";
import notify from "../../../Helpers/ToastNotification";
import { Collapse, Tooltip, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import OverflowTip from "../../../Components/OverflowToolTip/OverflowToolTip";
import { debounceSearchRender } from "mui-datatables";
import SelectForm from "../../../Components/SelectForm/SelectForm";
import DateForm from "../../../Components/DateForm/DateForm";
import DynamicGrid from "../../../Components/DynamicGrid/DynamicGrid";
import { ApplicationStatus } from "../../../Helpers/Enums/ApplicationStatus";
import { DATE_DISPLAY_FORMAT } from "../../../Helpers/Constants/Constants";
import { RoleEnum } from "../../../Helpers/Enums/RoleEnum";
import { StyledBadge } from "../../RegistrationRequest/RegistrationRequest";
import InputForm from "../../../Components/InputForm/InputForm";
import { Decrypt, Encrypt } from "../../../Helpers/Cryptography/Crypto";
import { MODES } from "../../../Helpers/Enums/Enum";
import { fetchAuthToken } from "../../../Helpers/Network/OAuthHandler";
import { Console } from "console";
import { ApiStatus } from "../../../Helpers/Enums/ApiStatus";

const LoanSettlementDashboard = () => {
  const { showLoader, hideLoader } = useContext(LoaderContext);
  const navigate = useNavigate();
  const context = getContext();

  const [dashboardData, setDashboardData] = useState([]);
  const [tabAllCount, setTabAllCount] = useState(0);
  const [tabPendingCount, setTabPendingCount] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [start, setStart] = useState(0);
  const [sortColumn, setSortColumn] = useState("");
  const [sortDirection, setSortDirection] = useState("");
  const [searchText, setSearchText] = useState("");
  const [count, setCount] = useState(0);
  const [dashboardFilterOn, setDashboardFilterOn] = useState<boolean>(false);
  const [resetClicker, setResetClicker] = useState<any>(false);
  const [reset, setReset] = useState(false);
  const [tabClickValue, setTabClickValue] = useState("All-Request-tab");
  const [tabClickAPIcall, setTabClickAPIcall] = useState({
    AllRequest: true,
    PendingRequest: false,
  });
  const [tabClickClass, setTabClickClass] = useState({
    AllRequest: "tab-pane fade  active show",
    PendingRequest: "tab-pane fade",
  });
  const [isAllRequestSelected, setIsAllRequestSelected] = useState<boolean>(true);

  useEffect(() => {
    if (resetClicker) {
      showLoader();
      onLoadDashboardData();
      hideLoader();
    }
  }, [resetClicker, start, sortColumn, sortDirection, searchText, reset]);
  useEffect(() => {
    showLoader();
    onLoadDashboardData();
    hideLoader();
  }, []);

  const onClickOftab = (event: any) => {
    setTabClickValue(event.target.id);
    onTabClickAPIcall(event.target.id);

    if (event.target.id == "All-Request-tab") {
      setIsAllRequestSelected(true);
    } else {
      setIsAllRequestSelected(false);
    }
  };

  const onLoadDashboardData = async () => {
    showLoader();

    let statusIdArr = [];
    // if (context?.loggedInAs?.value === RoleEnum.Admin) {
    //   statusIdArr = [
    //     ApplicationStatus.MemberRegistrationModule_PendingWithInternalTeam,
    //     //ApplicationStatus.MemberRegistrationModule_RejectedByInternalTeam,
    //     ApplicationStatus.MemberRegistrationModule_PendingWithEnrollmentCommittee,

    //   ];
    // } else if (context?.loggedInAs?.value === RoleEnum.EnrollmentCommittee) {
    //   statusIdArr = [
    //     ApplicationStatus.MemberRegistrationModule_PendingWithEnrollmentCommittee,
    //   ];
    // } else if (context?.loggedInAs?.value === RoleEnum.InternalTeam) {
    //   statusIdArr = [
    //     ApplicationStatus.MemberRegistrationModule_PendingWithInternalTeam,
    //   ];
    // } else if (context?.loggedInAs?.value === RoleEnum.HRHOD) {
    //   if (isAllRequestSelected) {
    //     statusIdArr = [
    //       ApplicationStatus.MemberRegistrationModule_PendingWithHRHOD,
    //       ApplicationStatus.MemberRegistrationModule_RejectedHRHOD,
    //       ApplicationStatus.MemberRegistrationModule_PendingWithMemberForPaymentDetails,
    //       ApplicationStatus.MemberRegistrationModule_PendingWithInternalTeam,
    //       ApplicationStatus.MemberRegistrationModule_RejectedByInternalTeam,
    //       ApplicationStatus.MemberRegistrationModule_PendingWithEnrollmentCommittee,
    //       ApplicationStatus.MemberRegistrationModule_MemberRequestApproved,
    //       ApplicationStatus.MemberRegistrationModule_MemberIDCreationCompleted,
    //       ApplicationStatus.MemberRegistrationModule_MemberRequestRejected,
    //     ];
    //   } else {
    //     statusIdArr = [
    //       ApplicationStatus.MemberRegistrationModule_PendingWithHRHOD,
    //     ];
    //   }
    // }

    // if (isAllRequestSelected) {
    //   if (context?.loggedInAs?.value === RoleEnum.Admin) {
    //     statusIdArr = [
    //       ...statusIdArr,
    //       ApplicationStatus.MemberRegistrationModule_Draft,
    //       ApplicationStatus.MemberRegistrationModule_PendingWithHRHOD,
    //       ApplicationStatus.MemberRegistrationModule_RejectedHRHOD,
    //       ApplicationStatus.MemberRegistrationModule_PendingWithMemberForPaymentDetails,
    //       ApplicationStatus.MemberRegistrationModule_RejectedByInternalTeam,
    //       ApplicationStatus.MemberRegistrationModule_MemberRequestApproved,
    //       ApplicationStatus.MemberRegistrationModule_MemberIDCreationCompleted,
    //       ApplicationStatus.MemberRegistrationModule_MemberRequestRejected,
    //       ApplicationStatus.MemberRegistrationModule_PendingWithEnrollmentCommittee,
    //     ];
    //   } else if (context.loggedInAs?.value === RoleEnum.InternalTeam) {
    //     statusIdArr = [
    //       ...statusIdArr,
    //       ApplicationStatus.MemberRegistrationModule_PendingWithInternalTeam,
    //       ApplicationStatus.MemberRegistrationModule_RejectedByInternalTeam,
    //       ApplicationStatus.MemberRegistrationModule_PendingWithEnrollmentCommittee,
    //       ApplicationStatus.MemberRegistrationModule_MemberRequestApproved,
    //       ApplicationStatus.MemberRegistrationModule_MemberRequestRejected,
    //     ];
    //   } else {
    //     statusIdArr = [
    //       ...statusIdArr,
    //       ApplicationStatus.MemberRegistrationModule_MemberRequestApproved,
    //       ApplicationStatus.MemberRegistrationModule_MemberIDCreationCompleted,
    //       ApplicationStatus.MemberRegistrationModule_MemberRequestRejected,
    //       ApplicationStatus.MemberRegistrationModule_PendingWithEnrollmentCommittee,
    //     ];
    //   }
    //   // statusIdArr = [
    //   //   ...statusIdArr,
    //   //   ApplicationStatus.MemberRegistrationModule_MemberRequestApproved,
    //   //   ApplicationStatus.MemberRegistrationModule_MemberRequestRejected,
    //   //   ApplicationStatus.MemberRegistrationModule_PendingWithEnrollmentCommittee,
    //   // ];
    // }

    // let statusIds = statusIdArr.join(",");

    // let requestParams = {
    //   start: start,
    //   resultsPerPage: pageSize,
    //   searchText: searchText,
    //   sortColumn: sortColumn,
    //   sortDirection: sortDirection,
    //   TypeofApplicantId:
    //     typeofApplicant && typeofApplicant.length > 0
    //       ? typeofApplicant.map(({ value }) => value).toString()
    //       : "",
    //   FromDate:
    //     fromDate === null || fromDate === ""
    //       ? ""
    //       : moment(fromDate).format("YYYY-MM-DD"),
    //   ToDate:
    //     toDate === null || toDate === ""
    //       ? ""
    //       : moment(toDate).format("YYYY-MM-DD"),
    //   StatusId: statusIds,
    //   UserId: context?.Id,
    //   RoleId: context?.loggedInAs?.value,
    // };

    // let RoleWiseParam = {};
    // if (context?.loggedInAs?.value === RoleEnum.HRHOD) {
    //   //alert(context.UnitCodeId.toString())
    //   
    //   RoleWiseParam = {
    //     ...requestParams,
    //     UnitCodeId: "context_UnitCodeId_toString",
    //     UnitCodeIds: context?.Roles.filter(role => role.RoleId === 6)[0].UnitCodes,
    //   };
    //   // UnitCodeIds: context?.UnitCodeIds,
    // } else {
    //   RoleWiseParam = {
    //     ...requestParams,
    //     UnitCodeId:
    //       unitCode && unitCode.length > 0
    //         ? unitCode.map(({ value }) => value).toString()
    //         : "",
    //     UnitCodeIds:
    //       unitCodeOptions && unitCodeOptions.length > 0
    //         ? unitCodeOptions.map(({ value }) => value).toString()
    //         : "",
    //   };
    // }
    const manualData = {
      Data: [
        {
          TotalCount: 100,
          // ... other properties
        },
        // Add more objects as needed
      ],
    };
    const res = await APICall("", "");

    if (res !== null && res.Data.length > 0) {
      // setDashboardData(res.Data);
      setDashboardData(manualData.Data);
      setCount(res.Data[0].TotalCount);
    } else {
      setDashboardData([]);
      setCount(0);
    }
    if (isAllRequestSelected) {
      setTabAllCount(res?.Data?.[0]?.TotalCount || 0);
    } else {
      setTabPendingCount(res?.Data?.[0]?.TotalCount || 0);
    }

    hideLoader();
  };

  const onTabClickAPIcall = async (param: any) => {
    await resetFunction();
    setDashboardFilterOn(false);
    switch (param) {
      case "All-Request-tab":
        setTabClickAPIcall({
          AllRequest: true,
          PendingRequest: false,
        });
        setTabClickClass({
          AllRequest: "tab-pane fade  active show",
          PendingRequest: "tab-pane fade",
        });
        break;
      case "Pending-Request-tab":
        setTabClickAPIcall({
          AllRequest: false,
          PendingRequest: true,
        });
        setTabClickClass({
          AllRequest: "tab-pane fade",
          PendingRequest: "tab-pane fade  active show",
        });
        break;
      default:
        setTabClickAPIcall({
          AllRequest: true,
          PendingRequest: false,
        });
        setTabClickClass({
          AllRequest: "tab-pane fade  active show",
          PendingRequest: "tab-pane fade",
        });
        break;
    }
  };

  // const onClickFunction = async (event, action) => {
  //   if (action === "Apply") {
  //     let isEmptyReqObj = false;
  //     if (dashboardFilterOn === true) {
  //       let reqFilterObj = {
  //         eventApplicantId:
  //           typeofApplicant && typeofApplicant.length > 0
  //             ? typeofApplicant.map(({ value }) => value).toString()
  //             : "",
  //         unitCodeId:
  //           unitCode && unitCode.length > 0
  //             ? unitCode.map(({ value }) => value).toString()
  //             : "",
  //         fromDate:
  //           fromDate === null || fromDate === ""
  //             ? null
  //             : moment(fromDate).format("YYYY-MM-DD"),
  //         toDate:
  //           toDate === null || toDate === ""
  //             ? null
  //             : moment(toDate).format("YYYY-MM-DD"),
  //       };
  //       isEmptyReqObj = Object.values(reqFilterObj).every((f) => {
  //         if (f === "" || f === null || f === undefined) {
  //           return true;
  //         } else {
  //           return false;
  //         }
  //       });
  //     }

  //     if (isEmptyReqObj === true) {
  //       notify(1, "Select at least one filter.");
  //     } else if (moment(fromDate).isAfter(moment(toDate))) {
  //       notify(1, "From Date should be less than To Date");
  //     } else if (fromDate && !toDate) {
  //       notify(1, "Select To Date");
  //     } else if (toDate && !fromDate) {
  //       notify(1, "Select From Date");
  //     } else {
  //       await onLoadDashboardData();
  //     }
  //   } else if (action === "Reset") {
  //     await resetFunction();
  //   }
  // };

  const dashboardOptions = {
    showEmptyDataSourceMessage: true,
    selectableRows: "none",
    count: count,
    rowsPerPage: pageSize,
    serverSide: true,
    rowsPerPageOptions: [],
    download: false,
    print: false,
    viewColumns: false,
    filter: false,
    search: false,
    responsive: "standard",
    customSearchRender: debounceSearchRender(500),
    onSearchChange: (searchText) => {
      if (searchText !== null) {
        setSearchText(searchText);
      } else {
        setSearchText("");
      }
    },
    onColumnSortChange: async (sortColumn, sortDirection) => {
      if (sortDirection === "asc") {
        await setSortColumn(sortColumn);
        await setSortDirection(sortDirection);
      }
      if (sortDirection === "desc") {
        await setSortColumn(sortColumn);
        await setSortDirection(sortDirection);
      }
    },
    onChangePage: async (page) => {
      setStart(page * pageSize);
    },
    textLabels: {
      body: {
        noMatch: "No data found",
      },
    },
  };

  const resetFunction = () => {
    // setFormErrors({});
    // formErrorObj = {};

    setReset(!reset);
  };

  const dashboardGridColumns = [
    {
      name: "Id",
      label: "ID",
      options: {
        display: false,
      },
    },
    // Token
    {
      name: "Loan Doc No",
      label: "Loan Doc No",
      options: {
        filter: true,
        sort: true,
        sortDescFirst: true,
        customBodyRender: (value, tableMeta) => {
          return (
            <>
              <OverflowTip>
                <Typography fontFamily={"Georama-Regular"} fontSize={"14px"} component={"span"} noWrap={true}>
                  {value}
                </Typography>
              </OverflowTip>
            </>
          );
        },
      },
    },

    {
      name: "LoanAmount",
      label: "Loan Amount",
      options: {
        filter: true,
        sort: true,
        sortDescFirst: true,
        customBodyRender: (value, tableMeta) => {
          return (
            <>
              <OverflowTip>
                <Typography fontFamily={"Georama-Regular"} fontSize={"14px"} component={"span"} noWrap={true}>
                  {value}
                </Typography>
              </OverflowTip>
            </>
          );
        },
      },
    },

    {
      name: "ApplicationDate",
      label: "Application Date",
      options: {
        filter: true,
        sort: true,
        sortDescFirst: true,
        customBodyRender: (value, tableMeta) => {
          return (
            <>
              <OverflowTip>
                <Typography fontFamily={"Georama-Regular"} fontSize={"14px"} component={"span"} noWrap={true}>
                  {value ? moment(value).format(DATE_DISPLAY_FORMAT) : ""}
                </Typography>
              </OverflowTip>
            </>
          );
        },
      },
    },

    {
      name: "LoanType",
      label: "Loan Type",
      options: {
        filter: true,
        sort: true,
        sortDescFirst: true,
        display: true,
        customBodyRender: (value, tableMeta) => {
          return (
            <>
              <OverflowTip>
                <Typography fontFamily={"Georama-Regular"} fontSize={"14px"} component={"span"} noWrap={true}>
                  {value}
                </Typography>
              </OverflowTip>
            </>
          );
        },
      },
    },

    {
      name: "OutstandingBalance",
      label: "Outstanding Balance",
      options: {
        filter: true,
        sort: true,
        sortDescFirst: true,
        display: true,
        customBodyRender: (value, tableMeta) => {
          return (
            <>
              <OverflowTip>
                <Typography fontFamily={"Georama-Regular"} fontSize={"14px"} component={"span"} noWrap={true}>
                  {value}
                </Typography>
              </OverflowTip>
            </>
          );
        },
      },
    },

    {
      name: "Loan Status",
      label: "Loan Status",
      options: {
        filter: true,
        sort: true,
        sortDescFirst: false,
        display: true,

        customBodyRender: (value, tableMeta) => {
          return (
            <>
              <OverflowTip>
                <Typography fontFamily={"Georama-Regular"} fontSize={"14px"} component={"span"} noWrap={true}>
                  {value}
                </Typography>
              </OverflowTip>
            </>
          );
        },
      },
    },
    {
      name: "StatusId",
      label: "StatusId",
      options: {
        filter: true,
        sort: true,
        sortDescFirst: true,
        display: false,
      },
    },
    {
      name: "Id",
      label: "Action",
      options: {
        filter: false,
        sort: false,
        display: true,
        setCellProps: () => ({
          style: { minWidth: "120px", maxWidth: "120px" },
        }),

        customBodyRender: (value, tableMeta) => {
          let id = tableMeta.tableData[tableMeta.rowIndex][0];
          let statusId = tableMeta.tableData[tableMeta.rowIndex][12];
          if (statusId) {
            statusId = parseInt(statusId);
          }

          if (statusId) {
            return (
              <>
                <Tooltip title="edit" className="ml-2">
                  <a
                    onClick={(e) => {
                      e.preventDefault();
                      // 0 = false and 1 = true
                      // navigate(
                      //   "/?id=" +
                      //     encodeURIComponent(Encrypt(id + "||1")),
                      //   {
                      //     // "&hide="+Encrypt("0")
                      //     state: { id: id, ShowHideButton: false },
                      //   }
                      // );
                    }}
                  >
                    <i className="fas fa-edit"></i>
                    {/* <i className="fa fa-pencil"></i> */}
                  </a>
                </Tooltip>
              </>
            );
          } else {
            return (
              <>
                <Tooltip title="view">
                  <a
                    onClick={(e) => {
                      e.preventDefault();
                      // navigate(
                      //   "/=" +
                      //     encodeURIComponent(Encrypt(id + "||0")),
                      //   {
                      //     // "&hide="+Encrypt("1")
                      //     state: { id: id, ShowHideButton: true },
                      //   }
                      // );
                    }}
                  >
                    <i className="fas fa-eye"></i>
                  </a>
                </Tooltip>
              </>
            );
          }
        },
      },
    },
  ];

  return (
    <>
      <div className="">
        <div className="">
          <div className="clearfix"></div>
          <div className="page-content row filter-row-container m-0">
            <div className="transformer-tabs col-lg-12 col-md-12">
              <div className="meeting-tabs tabs-main col-lg-12 pl-0">
                {/* <div className="page-content row filter-row-container mb-0 ml-0 mr-0"> */}
                <div className="col-lg-12 p-0">
                  <div className="row">
                    <div className="col-lg-5 col-md-5">
                      <nav className="tabs mr-sm-4 --jsfied">
                        <ul className="nav nav-pills  float-left -primary" id="pills-tab" role="tablist">
                          <StyledBadge badgeContent={tabAllCount} color="error" className="mr-3" max={99} invisible={true}>
                            <li className="nav-item" role="presentation">
                              <a
                                key="Dashboard"
                                className={tabClickValue === "All-Request-tab" ? "nav-link active" : "nav-link"}
                                id="All-Request-tab"
                                data-toggle="pill"
                                role="tab"
                                aria-controls="pills-MA"
                                aria-selected={tabClickValue === "All-Request-tab" ? "true" : "false"}
                                onClick={onClickOftab}
                              >
                                My Requests
                              </a>
                            </li>
                          </StyledBadge>
                          <StyledBadge badgeContent={tabPendingCount} color="error" className="mr-3" max={99} invisible={true}>
                            <li className="nav-item" role="presentation">
                              <a
                                key="Dashboard"
                                className={tabClickValue === "Pending-Request-tab" ? "nav-link active" : "nav-link"}
                                id="Pending-Request-tab"
                                data-toggle="pill"
                                role="tab"
                                aria-controls="pills-MA"
                                aria-selected={tabClickValue === "Pending-Request-tab" ? "true" : "false"}
                                onClick={onClickOftab}
                              >
                                Pending Requests
                              </a>
                            </li>
                          </StyledBadge>
                        </ul>
                      </nav>
                    </div>
                  </div>
                </div>
                {/* </div> */}
              </div>
            </div>
          </div>

          <div className="clearfix"></div>

          <>
            <div
              style={{
                paddingTop: "10px",
                paddingBottom: "10px",
                marginLeft: "1px",
              }}
              className="col-lg-12 px-0 py-2"
            >
              <div className="tab-contentMember">
                <div id="Request" role="tabpanel" aria-labelledby="Request-tab" key="Dashboard">
                  <div>
                    <Tooltip title="view">
                      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                      <a
                        className="pr-3"
                        onClick={(e) => {
                          e.preventDefault();
                          if (context?.CurrentRoleId === RoleEnum.Member) {
                            // navigate("/LoanDetailDashboard", {
                            //   state: { Id: id, mode: MODES.VIEW },
                            // });
                            navigate("/LoanSettlementTabs");
                          } else {
                            const viewPath = "/LoanSettlementTabs";
                            navigate(viewPath);
                          }
                        }}
                      >
                        <i className="fas fa-eye"></i>
                      </a>
                    </Tooltip>
                  </div>
                  {dashboardData && dashboardData.length >= 0 && <DynamicGrid options={dashboardOptions} data={dashboardData} columns={dashboardGridColumns} />}
                </div>
              </div>
            </div>
          </>
        </div>
      </div>
    </>
  );
};

export default LoanSettlementDashboard;
